/*
 * @Author: lixin jiang
 * @Date: 2021-07-07 09:33:00
 * @LastEditTime: 2022-06-13 17:55:52
 * @LastEditors: Yu Wang
 * @Description:
 * @FilePath: \kitchen-online-web\src\aid-base\components\ArcButton\arcButton.jsx
 */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ArcButtonGroupContext from '../../utils/buttonContext';
import buttonStyle from './arcButton.module.scss';

function ArcButton(props) {
  const {
    text,
    id,
    style,
    checked,
    disabled,
    handleChecked,
    unit,
    isBold,
    isSpacing,
  } = props;

  const {
    width, height, marginRight, fontSize = '14', backgroundColor,
  } = style;

  const context = React.useContext(ArcButtonGroupContext);

  const [focus, setFocus] = useState(false);

  // const iconSize = height / 1.71;

  // const iconToTop = (height - iconSize) / 2;

  const handleClickButton = () => {
    if (disabled) return;
    if (!backgroundColor) {
      setFocus(true);
    }
    handleChecked(id);
    if (context.onChange) {
      context.onChange(id);
    }
  };

  const handleBlurButton = () => {
    if (!backgroundColor) {
      setFocus(false);
    }
  };

  // const lightColors = ['#FFF', '#FFFFFF'];

  const fontColor = (disable) => {
    if (disable) {
      return '#DFDFDF';
    }
    return '#111';
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={
        `${buttonStyle['arc-button']}
        ${checked && focus && buttonStyle['arc-button-focus']}
        ${checked && !focus && buttonStyle['arc-button-active']}
        `
      }
      style={{
        ...style,
        width: `${width}${typeof width === 'number' ? unit : null}`,
        height: `${height}${unit}`,
        marginRight: `${isSpacing ? marginRight : ''}${unit}`,
        backgroundColor: disabled ? '#FFFFFF' : backgroundColor,
        cursor: disabled ? 'not-allowed' : '',
      }}
      onClick={() => handleClickButton()}
      onBlur={() => handleBlurButton()}
      aria-hidden
    >
      <span style={{
        color: `
        ${
          fontColor(disabled, backgroundColor)
        }
        `,
        fontSize: `${fontSize || '.875rem'}`,
        fontWeight: isBold ? 'bold' : 'normal',
      }}
      >
        {text}
      </span>
      {/* {
        backgroundColor ? null : (
          <div
            className={
            `${buttonStyle['arc-checked-icon']}
            ${buttonStyle['arc-icon']}
            ${focus ? buttonStyle['arc-focus-icon'] : buttonStyle['arc-checked-icon']}
            ${checked && buttonStyle['show-checked-icon']}
            ${checked && !focus && buttonStyle['show-checked-icon']}
            `
          }
            style={{
              width: `${iconSize}${unit}`,
              height: `${iconSize}${unit}`,
              top: `${iconToTop}${unit}`,
              right: `${iconToTop}${unit}`,
            }}
          />
        )
      } */}
    </div>
  );
}

ArcButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  text: PropTypes.string,
  checked: PropTypes.bool,
  handleChecked: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object]),
  unit: PropTypes.string,
  isBold: PropTypes.bool,
  isSpacing: PropTypes.bool,
};

ArcButton.defaultProps = {
  style: {
    backgroundColor: '',
    width: '', // 按钮宽度
    height: '', // 按钮高度
    fontSize: '14',
  },
  id: '',
  // 按钮背景色
  text: '', // 按钮文案
  checked: false, // 选中状态
  disabled: false, // 选中状态
  unit: 'rem',
  isBold: true,
  isSpacing: false,
  handleChecked: () => {}, // 点击事件
};

export default ArcButton;
